import './LoadingSpinner.css'

interface LoadingSpinnerProps {
  message?: string
  fullPage?: boolean
}

export function LoadingSpinner({ message = 'Loading...', fullPage = false }: LoadingSpinnerProps) {
  const content = (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <p>{message}</p>
    </div>
  )

  if (fullPage) {
    return (
      <div className="app-container">
        <div style={{ padding: '4rem' }}>
          {content}
        </div>
      </div>
    )
  }

  return content
}
